import React, { useState } from 'react';
import { KANBAN_FIELDS, TABLE_COLUMNS, getKanbanFieldPrefs, saveKanbanFieldPrefs, getTableColumnPrefs, saveTableColumnPrefs } from '@vanilla/constants/DealDisplayFields.js';
import { Button } from '@/components/ui/button';
import { NativeCheckbox } from '@/components/ui/checkbox';
import {
    Dialog,
    DialogContent,
    DialogTitle,
} from '@/components/ui/dialog';

export default function DisplaySettingsDialog({ onClose, onSaved }) {
    const [kanbanKeys, setKanbanKeys] = useState(() => getKanbanFieldPrefs());
    const [tableKeys, setTableKeys] = useState(() => getTableColumnPrefs());

    const toggleKanban = (key) => {
        setKanbanKeys((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));
    };

    const toggleTable = (key) => {
        setTableKeys((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));
    };

    const save = () => {
        saveKanbanFieldPrefs(kanbanKeys);
        saveTableColumnPrefs(tableKeys);
        window.dispatchEvent(new CustomEvent('displaySettingsChanged'));
        onSaved();
        onClose();
    };

    return (
        <Dialog open onOpenChange={(next) => { if (!next) onClose(); }}>
            <DialogContent
                unstyled
                hideClose
                id="displaySettingsModal"
                className="modal-content modal-small"
            >
                <div className="modal-header">
                    <DialogTitle unstyled>Display settings</DialogTitle>
                    <button type="button" className="modal-close" aria-label="Close" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body display-settings-body">
                    <section className="display-settings-section">
                        <h3>Kanban card fields</h3>
                        <p className="display-settings-hint">Choose extra data shown on each deal card. Deal name is always shown.</p>
                        <div id="displaySettingsKanban" className="display-settings-grid">
                            {KANBAN_FIELDS.map((f) => (
                                <label className="display-settings-option" key={f.key}>
                                    <NativeCheckbox unstyled
                                        checked={kanbanKeys.includes(f.key)}
                                        onChange={() => toggleKanban(f.key)}
                                    />
                                    <span>{f.label}</span>
                                </label>
                            ))}
                        </div>
                    </section>
                    <section className="display-settings-section">
                        <h3>Table columns</h3>
                        <p className="display-settings-hint">Choose columns in the deals table view.</p>
                        <div id="displaySettingsTable" className="display-settings-grid">
                            {TABLE_COLUMNS.map((c) => (
                                <label className="display-settings-option" key={c.key}>
                                    <NativeCheckbox unstyled
                                        checked={tableKeys.includes(c.key)}
                                        onChange={() => toggleTable(c.key)}
                                    />
                                    <span>{c.label}</span>
                                </label>
                            ))}
                        </div>
                    </section>
                    <div className="form-actions">
                        <Button type="button" className="btn btn-secondary" variant="secondary" id="displaySettingsCancel" onClick={onClose}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" variant="default" id="displaySettingsSave" onClick={save}>Save</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
